:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 720px) {
  :host(:not([dir="rtl"])) {
    padding-right: 24px;
  }

  :host([dir="rtl"]) {
    padding-left: 24px;
  }
}

.back-to-top {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  display: block;
  width: 48px;
  height: 48px;
  background-color: rgba(51, 51, 51, 0.5);
  color: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.25s ease-out;
}

.back-to-top:hover {
  background-color: rgba(51, 51, 51, 0.7);
}

.back-to-top:active {
  background-color: #333333;
}

.back-to-top--shown {
  animation: show 0.25s ease-out;
  opacity: 1;
}

.back-to-top--hidden {
  animation: hide 0.25s ease-out;
  opacity: 0;
}

@keyframes show {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

@keyframes hide {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(100%);
  }
}

.back-to-top__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
}